<template>

	<v-row justify="center">

	<v-dialog
		v-model="dialog"
		scrollable
		max-width="550px"
		persistent
		style="z-index: 150;"
	>

		<v-card>

			<v-card-title
				style="height: 50px; border-bottom-left-radius: 0; border-bottom-right-radius: 0;"
				class="primary white--text text--darken-2 pt-3"
			>Select what to give access too</v-card-title>

			<div style="padding-left: 25px; height: 70px; padding-right: 25px;" class="body-2 primary primary--text text--lighten-4">Note: If you choose the parent node (the client or the project groups), the user will have access to ALL groups and projects nested in this node.</div>

			<v-divider/>

			<v-card-text style="height: 300px;" class="ma-0 pa-0">
				<v-container fluid  class="ma-0 pa-0">
					<v-row no-gutters>

						<v-col>
							<v-treeview
								ref="treeElement"
								v-model="tree"
								:open="folderOpen"
								:items="treeItems"
								activatable
								item-key="id"
								
								:active.sync="treeActiveItem"
								return-object
								dense
								:class="`grey lighten-4 overflow-y-auto ${showTree ? '' : 'd-none'}`"
								style="height: 300px"
							>
								<template v-slot:prepend="{ item, open }">
									<v-icon v-if="!item.iconType" color="grey darken-2">
										{{ open ? 'mdi-folder-open' : 'mdi-folder' }}
									</v-icon>
									<v-icon v-else color="grey darken-2">
										{{ iconTypes[item.iconType] }}
									</v-icon>
								</template>
							</v-treeview>

							<!-- <v-col class="pl-4"> -->
							<div
								:class="`pl-4 ${showTree ? 'd-none' : ''}`"
							>
								<v-subheader class="title ml-0 pl-0 mb-0 pb-0"><b>Choose access level:</b></v-subheader>
								<v-radio-group v-model="radioGroup" dense class="mt-3 pl-4">

									<v-radio v-if="showDeveloperRadio"
										label="Developer"
										value="dev"
									></v-radio>

									<v-radio
										label="Admin"
										value="adm"
									></v-radio>

									<v-radio
										label="Editor"
										value="edi"
									></v-radio>

									<v-radio
										label="Reader"
										value="rea"
									></v-radio>

									<v-radio
										label="Guest"
										value="gue"
									></v-radio>

								</v-radio-group>
							</div>

						</v-col>

					</v-row>
				</v-container>
			</v-card-text>

			<v-divider/>
			
			<v-card-actions>
				<v-spacer/>

				<v-btn
					color="blue darken-1"
					text
					@click="chooseProject"
					:disabled="fireBaseInProgress"
					:loading="fireBaseInProgress"
				>
					{{ okButtonText }}
				</v-btn>

				<v-btn
					color="blue darken-1"
					text
					@click="dialog = false"
					:disabled="fireBaseInProgress"
				>
					Cancel
				</v-btn>

				<v-spacer/>
			</v-card-actions>
		</v-card>
	</v-dialog>

	</v-row>

</template>

<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import fb from '@/shift/fb';
import agileFb from '@/shift/agileFb';
import agile from '@/shift/agile';

export default
{
	name: 'ChooseProjectForAccess',

	// ----------------------------------
	//	Data
	// ----------------------------------

	data: () =>
	({
		
		dialog: false,

		radioGroup: 'none',

		folderOpen: ['public'],
		iconTypes:
		{
			clientIcon: 'mdi-folder-account',
			groupIcon: 'mdi-animation',
			projectIcon: 'mdi-television-clean',
		},
		
		tree: [],
		treeItems: [],
		treeActiveItem: [],

		okButtonText: '',
		okButtonDefaultText: 'Choose selected project',

		showTree: true,
		uid: '',
		fireBaseInProgress: false,

		showDeveloperRadio: false,
	}),

	computed:
	{
		agile()
		{
			return agile;
		},
	},

	create()
	{

	},

	// ----------------------------------
	//	Methods
	// ----------------------------------

	methods:
	{

		// ----------------------------------
		//	Choose the project to access
		// ----------------------------------

		chooseProject()
		{
			let selectedTreeItem;

			if (this.showTree) // Means we clicked from tree view. Todo: Damn this is bad coding. But I am tired!!
			{
				if (!this.treeActiveItem || this.treeActiveItem.length == 0)
				{
					this.$root.$alert("Select something", "No projects, groups or clients selected.");
				}
				else
				{
					// Yea yea, like this was necessary :p
					selectedTreeItem  = this.treeActiveItem[0];

					//console.log("ADM", selectedTreeItem.admin);

					if (!selectedTreeItem.admin)
					{
						this.$root.$alert("No permission", "You do not have the access level required to add this client or group level. Try adding group or project.");
					}
					else
					{
						//console.log(selectedTreeItem);
						
						if (selectedTreeItem.accessMap.group == "*")
						{
							this.$root.$confirm("Confirm!", `The user will have access to ALL the ${selectedTreeItem.name} project groups and projects (also future projects). Are you sure? If you want to give access to a specific project, expand the client tree.`)
							.then((confirm) =>
							{
								if (confirm) moveOn.bind(this)(selectedTreeItem);
							});
						}
						else if (selectedTreeItem.accessMap.project == "*")
						{
							this.$root.$confirm("Confirm!", `The user will have access to ALL the ${selectedTreeItem.clientName}'s projects (also future projects) in the project group ${selectedTreeItem.name}. Are you sure?`)
							.then((confirm) =>
							{
								if (confirm) moveOn.bind(this)(selectedTreeItem);
							});
						}
						else
						{
							moveOn.bind(this)(selectedTreeItem);
						}
					}

					
				}
			}
			else
			{
				// ----------------------------------
				//	Choose access level
				// ----------------------------------
				
				if (this.radioGroup === 'none')
				{
					this.$root.$alert('No access level selected', 'You have to select access level!');
				}
				else
				{
					selectedTreeItem  = this.treeActiveItem[0];
					
					// --------------------------------------------------------------------
					//
					//	Set custom claims here in Firebase Cloud Function
					//
					// --------------------------------------------------------------------

					this.fireBaseInProgress = true;

					const addUserAccessCard = fb.functions.httpsCallable('addUserAccessCard');
					
					addUserAccessCard(
					{
						uid: this.uid,
						accessCard:
						{
							master: selectedTreeItem.accessMap.master,
							group: selectedTreeItem.accessMap.group,
							project: selectedTreeItem.accessMap.project
						},
						accessLevel:
						{
							dev: (this.radioGroup === 'dev') ? true : false ,
							adm: (this.radioGroup === 'dev' || this.radioGroup === 'adm') ? true : false ,
							edi: (this.radioGroup === 'dev' || this.radioGroup === 'adm' || this.radioGroup === 'edi') ? true : false ,
							rea: true, // Reader and guest are the same
							gue: true // Always true, if not even guest access, then the user should be disabled instead.
						}
					} )
					.then(result =>
					{
						
						this.fireBaseInProgress = false;

						if (result.data.success)
						{
							
							//console.log("Added user accessCard", result.data.userId);
							//console.log(result.data.aiData);

							this.$root.ai_app.snackbarText = 'User access added';
							this.$root.ai_app.snackbarTimeout = 4000;
							this.$root.ai_app.snackbar = true;

							// Emit event so we can update user data in parent window
							this.$emit('access-card-added');

							agileFb.updateUsersAccessCards();

							// Close the window now
							this.dialog = false;

						}
						else
						{
							this.$root.$alert("Error", result.data.error.message);
						}
						
					})
					.catch(er =>
					{
						this.fireBaseInProgress = false;
						this.$root.$alert("Error", er);
					});

				}
				
			}

			
			
			function moveOn(selectedTreeItem)
			{
				this.showDeveloperRadio = selectedTreeItem.access.dev;
				this.okButtonText = "Give access";
				this.showTree = false;
			}

			

		},



		// ----------------------------------
		//	Load data and open the dialog
		// ----------------------------------

		open(_uid)
		{
			this.uid = _uid;

			// Reset UI values
			this.okButtonText = this.okButtonDefaultText;
			this.showTree = true;
			this.treeActiveItem = [];
			this.radioGroup = 'none';

			// Move on
			//this.$root.ai_app.showProgressWheel = true;

			const clients = agile.getClients();
			const groups = agile.getProjectGroups();
			const projects = [];


			for (let i = clients.length-1; i >= 0; i--)
			{
				clients[i].children = [];
				clients[i].iconType = 'clientIcon';
				clients[i].accessMap = { master: clients[i].key, group: '*', project: '*'  } ;

				// If user adding new access does not have admin at any level for this client, then remove this entry from the tree menu.
				if (!clients[i].hasAdminAccessInSub) clients.splice(i, 1);
			}

			
			for (let i = 0; i < groups.length; i++)
			{
				groups[i].children = [];
				groups[i].iconType = 'groupIcon';
				groups[i].parentId = groups[i].clientId;
				groups[i].accessMap = { master: groups[i].clientKey, group: groups[i].key, project: '*'  } ;
			}

			for (let i = 0; i < agile.loggedInUser.projects.length; i++)
			{
				projects.push(Object.assign({}, agile.loggedInUser.projects[i]));
				projects[i].iconType = 'projectIcon';
				projects[i].parentId = projects[i].groupId;
				projects[i].admin = (agile.loggedInUser.projects[i].access.dev || agile.loggedInUser.projects[i].access.adm);
				projects[i].accessMap = { master: projects[i].clientKey, group: projects[i].groupKey, project: projects[i].projectKey } ;
			}


			// ----------------------------------
			//	Build tree object
			// ----------------------------------
			
			// Put groups in clients
			for (let i = 0; i < clients.length; i++)
			{
				for (let j = 0; j < groups.length; j++)
				{
					if (clients[i].id === groups[j].parentId) clients[i].children.push(groups[j]);
				}
			}

			// Put projects in groups
			for (let j = 0; j < groups.length; j++)
			{
				for (let k = 0; k < projects.length; k++)
				{
					if (groups[j].id === projects[k].parentId) groups[j].children.push(projects[k]);
				}
			}


			// Now, use clients structure as tree data
			this.treeItems = clients;

			console.log(this.treeItems);

			// Actually open dialog window now
			this.dialog = true;

			
		},

		
	}

}
</script>